import React, { useState } from "react";
import { Link } from "react-router-dom";
import "swiper/swiper-bundle.css";
import { toast } from "react-toastify";
import { useTMDBSearch } from "../../../hooks/useTMDB";
import { CompactWatchlistButtons } from "../../../components/WatchlistButtons";

import img4 from "../../../assets/images/upcoming/04.jpg";
import img6 from "../../../assets/images/upcoming/03.jpg";
import img7 from "../../../assets/images/upcoming/04.jpg";
import img1 from "../../../assets/images/trending/02.jpg";
import img2 from "../../../assets/images/trending/03.jpg";
import img3 from "../../../assets/images/trending/04.jpg";
import img5 from "../../../assets/images/trending/05.jpg";

const moivedata = [
  {
    imgSrc: img1,
    title: "The Lost Journey",
    ageRating: "20+",
    duration: "2h 15m",
    link: "/show-details",
  },
  {
    imgSrc: img2,
    title: "Boop Bitty",
    ageRating: "11+",
    duration: "2h 30m",
    link: "/show-details",
  },
  {
    imgSrc: img3,
    title: "Unknown Land",
    ageRating: "17+",
    duration: "2h 30m",
    link: "/show-details",
  },
  {
    imgSrc: img5,
    title: "Blood Block",
    ageRating: "13+",
    duration: "2h 30m",
    link: "/show-details",
  },
  {
    imgSrc: img4,
    title: "Champions",
    ageRating: "13+",
    duration: "2h 30m",
    link: "/show-details",
  },
  {
    imgSrc: img6,
    title: "The Lost Journey",
    ageRating: "20+",
    duration: "2h 15m",
    link: "/show-details",
  },
  {
    imgSrc: img7,
    title: "Boop Bitty",
    ageRating: "11+",
    duration: "2h 30m",
    link: "/show-details",
  },
  {
    imgSrc: img3,
    title: "Unknown Land",
    ageRating: "17+",
    duration: "2h 30m",
    link: "/show-details",
  },
  {
    imgSrc: img6,
    title: "Blood Block",
    ageRating: "13+",
    duration: "2h 30m",
    link: "/show-details",
  },
  {
    imgSrc: img5,
    title: "Champions",
    ageRating: "13+",
    duration: "2h 30m",
    link: "/show-details",
  },
  {
    imgSrc: img1,
    title: "The Lost Journey",
    ageRating: "20+",
    duration: "2h 15m",
    link: "/show-details",
  },
  {
    imgSrc: img2,
    title: "Boop Bit<｜tool▁sep｜>",
    ageRating: "11+",
    duration: "2h 30m",
    link: "/show-details",
  },
  {
    imgSrc: img3,
    title: "Unknown Land",
    ageRating: "17+",
    duration: "2h 30m",
    link: "/show-details",
  },
  {
    imgSrc: img4,
    title: "Blood Block",
    ageRating: "13+",
    duration: "2h 30m",
    link: "/show-details",
  },
  {
    imgSrc: img5,
    title: "Champions",
    ageRating: "13+",
    duration: "2h 30m",
    link: "/show-details",
  },
];

const SearchPage = () => {
  const [query, setQuery] = useState("");
  
  // Use the TMDB search hook
  const {
    results: tmdbResults,
    loading,
    error,
    totalPages,
    totalResults
  } = useTMDBSearch(query, { debounceMs: 800 }); // Increased debounce time

  const handleAddClick = (Data) => {
    toast.success(Data, {
      position: "top-right",
      autoClose: 3000, 
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const copyURL = () => {
    const url = window.location.href;
    const tempInput = document.createElement("input");
    document.body.appendChild(tempInput);
    tempInput.value = url;
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    toast.success("URL copied to clipboard: " + url);
  };

  const handleInputChange = (e) => {
    setQuery(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Submit handled automatically by debounced search
  };

  // Helper component for rendering movie cards
  const MovieCard = ({ item, isTmdbResult = false }) => (
    <li key={isTmdbResult ? `tmdb-${item.id}` : `local-${item.title}`} className="slide-item col-lg-3 col-md-4 col-6 mb-4">
      <div className="block-images position-relative watchlist-first">
        <div className="img-box">
          <img
            src={item.imgSrc}
                            className="img-fluid"
            alt={item.title}
            onError={(e) => {
              e.target.src = img4; // Fallback to local image
            }}
                          />
                        </div>
        <div className="block-description">
          <h6 className="iq-title text-left">
            <Link to={item.link}>
              {item.title}
            </Link>
                          </h6>
          <div className="movie-time d-flex align-items-center my-2">
            <span className="text-white">{item.duration}</span>
            {isTmdbResult && item.year && item.year !== 'N/A' && (
              <>
                <span className="text-white ml-2">•</span>
                <span className="text-white ml-2">{item.year}</span>
              </>
            )}
                          </div>
          <div className="hover-buttons text-left">
                            <Link
              to={item.link}
                              role="button"
              className="btn btn-hover"
                            >
              <i className="fa fa-play mr-1" aria-hidden="true"></i>
                              Play Now
                            </Link>
                          </div>
                        </div>
        <div className="block-social-info">
          <ul className="list-inline p-0 m-0 music-play-lists">
            <li className="share">
                              <span>
                <i className="ri-share-fill"></i>
                              </span>
              <div className="share-box">
                <div className="d-flex align-items-center">
                                <a
                    href="https://www.facebook.com/sharer?u=http://localhost:3000"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="share-ico"
                                      tabIndex="0"
                                    >
                    <i className="ri-facebook-fill"></i></a>
                                    <a
                    href="https://twitter.com/intent/tweet?text=Check out this movie!"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="share-ico"
                                      tabIndex="0"
                                    >
                                      <i className="ri-twitter-fill"></i>
                                    </a>
                                    <a
                                       onClick={copyURL}
                                      className="share-ico iq-copy-link"
                                      tabIndex="0"
                                    >
                                      <i className="ri-links-fill"></i>
                                    </a>
                                </div>
                              </div>
                            </li>
                            <CompactWatchlistButtons item={{
                              id: isTmdbResult ? parseInt(item.id) : parseInt(Math.random() * 10000),
                              title: item.title,
                              type: isTmdbResult ? (item.media_type || 'movie') : 'movie',
                              poster_path: item.imgSrc?.includes('tmdb.org') ? item.imgSrc.split('/').pop() : null,
                              imgSrc: item.imgSrc,
                              vote_average: item.vote_average,
                              release_date: item.year || item.release_date,
                              overview: item.overview,
                              adult: item.adult
                            }} />
                          </ul>
                        </div>
                      </div>
                    </li>
  );

  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            100% { opacity: 0.5; }
          }
        `}
      </style>
      <div>
        <main id="main" className="site-main watchlist-contens parent_for_search">
          <div className="container-fluid">
            <form className="search-cls" onSubmit={handleSubmit}>
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="fa fa-search"></i>
                  </span>
                </div>
                <input
                  className="custm-search"
                  type="text"
                  placeholder="Movies, series and more"
                  value={query}
                  onChange={handleInputChange}
                  style={{ border: "1px solid white" }}
                          />
                        </div>
            </form>
            
            <div className="iq-main-header d-flex align-items-center justify-content-between mt-5 mt-lg-0">
              <h4 className="main-title">
                {tmdbResults.length > 0 ? (
                  <>
                    Search Results for "{query}" 
                    <small className="d-block text-muted">
                      Found {totalResults} results across {totalPages} pages
                    </small>
                  </>
                ) : (
                  "Popular Searches"
                )}
              </h4>
                          </div>

            {/* Loading indicator */}
            {loading && (
              <div className="text-center py-4">
                <div className="spinner-border text-light" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <p className="text-white mt-2">Searching movies and TV shows...</p>
              </div>
            )}

            {/* Error message */}
            {error && (
              <div className="text-center py-4">
                <div className="alert alert-danger" role="alert">
                  <i className="ri-error-warning-line me-2"></i>
                  {error}
                </div>
              </div>
            )}

            {/* Search results or default movies - stable rendering */}
            {!loading && (
              <ul className="row list-inline mb-0 iq-rtl-direction">
                {query.length > 0 && tmdbResults.length > 0 ? (
                  tmdbResults.filter(item => item.media_type !== 'person').map((item) => 
                    <MovieCard key={item.id} item={item} isTmdbResult={true} />
                  )
                ) : query.length > 0 && tmdbResults.length === 0 ? (
                  <div className="col-12 text-center py-4">
                    <p className="text-white">No results found for "{query}". Try a different search term.</p>
                  </div>
                ) : (
                  moivedata.map((item) => <MovieCard key={item.title} item={item} isTmdbResult={false} />)
                )}
              </ul>
            )}

          </div>
        </main>
      </div>
    </>
  );
};

export default SearchPage;